import { Component, type ReactNode } from 'react';

/**
 * Keeps one part of the editor from taking the rest down with it.
 *
 * There was no error boundary anywhere, so a throw while drawing any panel — a hand-written
 * add-on with a malformed option list was one — blanked the whole editor, every time it
 * was opened (QA 2026-09-24, library-addons-F1). Wrapped round a panel, a throw now
 * leaves a short message in the panel and everything else working.
 */
export class Boundary extends Component<{ children: ReactNode; message?: string }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: unknown): void {
    console.error('A panel failed to draw', error);
  }

  override render(): ReactNode {
    if (this.state.failed) {
      return <p className="p-[12px] text-[12px] text-label-2">{this.props.message ?? 'This panel ran into a problem. Close it and open it again.'}</p>;
    }
    return this.props.children;
  }
}
